import { Component, EventEmitter, forwardRef, HostBinding, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QuestionAnswer } from 'src/app/modal/questionnaire.models';
import { NfpNumbericQuestionComponent } from '../nfp-numberic-question/nfp-numberic-question.component';

@Component({  
  template: ``,
  styles: [],
  providers: []
})
export class NfpBaseInputControlComponent  implements ControlValueAccessor {

    @Input() question: QuestionAnswer;        
    @Input() isFormSubmitted: boolean;        
    @Input() label: string;
    @Input() waterMark: string;   
    @Input() maxAmt: number;
    @Input() minAmt: number;
    @Input() maxlength;
    @Input() minlength;
    @Input() validationMessage: string;
    @Input() meAsControl: FormControl;

    touched = false;
    disabled = false;
    onChange = (answer: string) => {};
    onTouched = () => {};

    constructor() {
      
    }

    ngOnInit() {
      
    }

    get value() {
      return this.question.answer;
    }
    
    set value(val) {
      this.question.answer = val;
      this.onChange(val);
      this.onTouched();
    }

    writeValue(answer: string): void {
      this.value = answer;
    }

    registerOnChange(onChange: any) {
      this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
      this.onTouched = onTouched;
    }

    markAsTouched() {
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }

    }
    valueChanged(val: string) {
        this.onChange(val);
        this.markAsTouched();
    }
      
    setDisabledState(disabled: boolean) {
      this.disabled = disabled;
    }
}
